<template lang="pug">
  div.confirm-layout
    div.alert.alert-success
      span 此藥物總存量:  {{ selectedDrugTotalAmount }}
      span.float-right 
    RxCheckBarcode(
      v-if="currentProgress === 'rxCheck'"
      v-on:confirmRx="confirmRx"
    )
    ActionWrap(
      v-if="currentProgress === 'action'"
      v-on:setActionData="getFetchData"
      :actionProgress="actionProgress"
      :medRecordId="medRecordId"
      :amount="currentDrug.amount"
      :reviewer="reviewer"
    )

</template>

<script>
import ConfirmFlowBase from '../ComponentBase/ConfirmFlowBase';
import ActionWrap from './ActionWrap';
import RxCheckBarcode from '../flowComp/RxCheckBarcode';


export default {
  name: 'ConfirmFlow',
  extends: ConfirmFlowBase,
  props: ['confirmProgress','medRecordId'],
  data() {
    return {
      reviewer: undefined,
    };
  },
  components: {
    ActionWrap,
    RxCheckBarcode,
  },
  created() {
    this.$store.dispatch('getDrugInDevicesWithSameDrug', this.currentDrug.med.id);
  },
  mounted() {
    console.log('mounted');
    this.nextProgress();
  },
  computed: {
  },
  methods: {
    getFetchData(data) {
      //this.resetProgress();
      //console.log('get from actionwrap');
      this.$emit('confirmationFinish');
      // gave time for component unmount
      //setTimeout(() => {
      //  this.nextProgress();
      //}, 100);
    },
    confirmRx(reviewer) {
      this.reviewer = reviewer;
      this.nextProgress();
    },
  },
};
</script>




// WEBPACK FOOTER //
// ConfirmFlow.vue?db78d4a4